/**
 * @description 程序包管理 programPackageManage
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const programPackageManageBiz = new Logic()

programPackageManageBiz.findAllPackage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.findAllPackage,
    data: data
  })
}

programPackageManageBiz.saveAppPackage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.saveAppPackage,
    data: data
  })
}

programPackageManageBiz.deleteAppPackage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.deleteAppPackage,
    data: data
  })
}

programPackageManageBiz.checkPath = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.checkPath,
    data: data
  }, true)
}

programPackageManageBiz.saveRealase = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.saveRealase,
    data: data
  })
}

programPackageManageBiz.findRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.findRelease,
    data: data
  })
}

programPackageManageBiz.deleteRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.deleteRelease,
    data: data
  })
}

programPackageManageBiz.getAppPackage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.getAppPackage,
    data: data
  })
}

programPackageManageBiz.updatePackage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.updatePackage,
    data: data
  })
}

programPackageManageBiz.findSingleRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.findSingleRelease,
    data: data
  })
}

programPackageManageBiz.updateRealase = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.updateRealase,
    data: data
  })
}

programPackageManageBiz.uploadFile = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.uploadFile,
    data: data
  })
}

programPackageManageBiz.getAllGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.getAllGroup,
    data: data
  })
}

programPackageManageBiz.findAppByGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.programPackageManage.findAppByGroup,
    data: data
  })
}

export default programPackageManageBiz
